import React from 'react';
import PropTypes from 'prop-types';

import ErrorMessage from './error-message.js';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: '' };
  }

  static getDerivedStateFromError(error) {
    console.log(error, 'error')
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorMsg: error };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
  }

  render() {
    // if (this.state.hasError) {
    //   return <ErrorMessage errorMsg={this.state.errorMsg} />;
    // }
    return this.props.children; 
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array
  ])
};

export default ErrorBoundary;
